<div class="eyeicon-scroll-container" style="padding-bottom: 0;"
  infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()">
  <div class="col-sm-12 col-lg-12 col-md-12">
    <div class="row">

      <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="invitedCandidateList | async as response">
        <app-candidate-job-details class="candidateJobContent" *ngIf="response?.length > 0"
          [interactionResponse]="response" [cardContent]="'INVITE'"></app-candidate-job-details>
        <app-common-skeleton *ngIf="loadAPIcall && response?.length > 0" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      </div>

      <div class="col-sm-12 pl-1 end" *ngIf="invitedCandidateListStopScroll && (invitedCandidateList | async)?.length > 0" style="text-align: center;padding-top: 1rem;">
        <div class="col-sm-12">
          <ng-icon name="tablerCircleCheck"></ng-icon>
        </div>
        <div class="col-sm-12">
          <p class="biase">You've reached the bottom of the page</p>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12" *ngIf="loadAPIcall && (invitedCandidateList | async)?.length == 0">
    <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
  </div>
  <div class="col-12" *ngIf="!loadAPIcall && (invitedCandidateList | async)?.length == 0">
    <div class="gs-empty">
      <span class="gs-empty-icon"><ng-icon name="tablerSend"></ng-icon></span>
      <div class="gs-empty-title">No invites sent yet</div>
      <div class="gs-empty-sub">Invites you send will appear here.</div>
    </div>
  </div>
</div>
